export const FILE_TOASTS = {
  UPLOADED_MULTIPLE: 'Files successfully uploaded',
  FILES_MOVED: 'Selected files were moved to {collectionName} successfully',
  MAX_FILE_COUNT_EXCEEDED: 'Please upload fewer than {maxNum} files',
  FILE_UPDATED: 'File successfully updated',
  FILE_DELETED: 'File successfully deleted',
  FILE_DOWNLOAD_EXPIRATION: 'The download link has expired. Please request your files again.',
};
